import { render, staticRenderFns } from "./OperationsTable.vue?vue&type=template&id=8ebc034e&scoped=true"
import script from "./OperationsTable.vue?vue&type=script&lang=js"
export * from "./OperationsTable.vue?vue&type=script&lang=js"
import style0 from "./OperationsTable.vue?vue&type=style&index=0&id=8ebc034e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ebc034e",
  null
  
)

export default component.exports